// Vendors
import { isLikelyWebViewDevice } from '@openbank/cf-ui-framework';
// Constants
import {
  BACKGROUND_PAGE_RELOADED_CUSTOM_ACTION,
  BACKGROUND_HAPPENED_NOT_SHOWN_CUSTOM_ACTION,
} from './constants/background-log.handlers.constants';
import {
  BEFORE_UNLOAD_EVENT,
  VISIBILITY_CHANGE_EVENT,
} from './constants/background.handlers.constants';
// Event Handlers
import {
  getCustomActionAccordingVisibility,
  hasReloadPerformanceEntry,
  isBackgroundWhiteListedFlow,
} from './utils/background.handlers.utils';
// Types
import {
  BackgroundHandlersBuilderType,
  BackgroundHandlersReturnType,
} from './types/background.handlers.type';

let BEFORE_UNLOAD_EVENT_SET, VISIBILITY_CHANGE_EVENT_SET;

const browserVisibilityCallbackMethodHandler = ({
  handleSendCustomActionEvent,
  setShowBackgroundModal,
}: Omit<BackgroundHandlersBuilderType, 'currentState'>): void => {
  const visible = !document.hidden;

  handleSendCustomActionEvent(getCustomActionAccordingVisibility(visible));
  setShowBackgroundModal(visible);
};

const watchBrowserInBackgroundOutEventHandler = ({
  currentState,
  handleSendCustomActionEvent,
  ...props
}: BackgroundHandlersBuilderType): void => {
  if (isLikelyWebViewDevice()) {
    VISIBILITY_CHANGE_EVENT_SET = () => {
      if (isBackgroundWhiteListedFlow(currentState)) {
        handleSendCustomActionEvent(BACKGROUND_HAPPENED_NOT_SHOWN_CUSTOM_ACTION + currentState);
      } else {
        browserVisibilityCallbackMethodHandler({ ...props, handleSendCustomActionEvent });
      }
    };
    document.addEventListener(VISIBILITY_CHANGE_EVENT, VISIBILITY_CHANGE_EVENT_SET);
  }
};

const browserReloadCallbackMethodHandler = handleSendCustomActionEvent => {
  if (hasReloadPerformanceEntry()) {
    handleSendCustomActionEvent(BACKGROUND_PAGE_RELOADED_CUSTOM_ACTION);
  }
};

const watchBrowserReloadOutEventHandler = (
  handleSendCustomActionEvent: BackgroundHandlersBuilderType['handleSendCustomActionEvent']
): void => {
  BEFORE_UNLOAD_EVENT_SET = () => {
    browserReloadCallbackMethodHandler(handleSendCustomActionEvent);
  };
  window.addEventListener(BEFORE_UNLOAD_EVENT, BEFORE_UNLOAD_EVENT_SET);
};

const removeBrowserNativeEventsWatchersEventHandler = () => {
  window.removeEventListener(BEFORE_UNLOAD_EVENT, BEFORE_UNLOAD_EVENT_SET);
  document.removeEventListener(VISIBILITY_CHANGE_EVENT, VISIBILITY_CHANGE_EVENT_SET);
};

const watchBrowserNativeEventsOutEventHandler = ({
  handleSendCustomActionEvent,
  ...props
}: BackgroundHandlersBuilderType): void | (() => void) => {
  watchBrowserInBackgroundOutEventHandler({ ...props, handleSendCustomActionEvent });
  watchBrowserReloadOutEventHandler(handleSendCustomActionEvent);
};

const BackgroundHandlers = (
  props: BackgroundHandlersBuilderType
): BackgroundHandlersReturnType => ({
  handleWatchBrowserNativeEventsOutEvent: () => watchBrowserNativeEventsOutEventHandler(props),
  handleRemoveBrowserNativeEventsWatchersEvent: () =>
    removeBrowserNativeEventsWatchersEventHandler(),
});

export { BackgroundHandlers };
